import { useCallback, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Briefcase, Users, Star, TrendingUp, RefreshCw, ArrowRight } from 'lucide-react'
import KpiTile from '../training/KpiTile'
import { Widget } from './DashboardWidgets'
import { hrDashboard } from '../../api/hrDashboard'

export default function RecruiterDashboard() {
    const navigate = useNavigate()
    const [stats, setStats] = useState(null)
    const [loading, setLoading] = useState(true)
    const [refreshing, setRefreshing] = useState(false)

    const load = useCallback(async (quiet = false) => {
        if (!quiet) setLoading(true)
        else setRefreshing(true)
        try {
            const data = await hrDashboard.recruitingOverview()
            setStats(data)
        } catch {
            // noop — show zeros
        } finally {
            setLoading(false)
            setRefreshing(false)
        }
    }, [])

    useEffect(() => { load() }, [load])

    const s = stats || {}

    return (
        <div className="page-content stagger-children">
            {/* KPI row */}
            <div
                className="stagger-children grid gap-8"
                style={{ gridTemplateColumns: 'repeat(auto-fill, minmax(140px, 1fr))', alignItems: 'stretch' }}
            >
                <KpiTile
                    icon={Briefcase}
                    label="Открытых вакансий"
                    value={loading ? '…' : (s.active_vacancies ?? 0)}
                    tone="info"
                    hint="Активных вакансий сейчас"
                />
                <KpiTile
                    icon={Users}
                    label="В воронке"
                    value={loading ? '…' : (s.candidates_in_pipeline ?? 0)}
                    tone={s.candidates_in_pipeline > 0 ? 'info' : 'neutral'}
                    hint="Кандидатов в активных этапах"
                />
                <KpiTile
                    icon={Star}
                    label="Готовы к офферу"
                    value={loading ? '…' : (s.at_offer_stage ?? 0)}
                    tone={s.at_offer_stage > 0 ? 'warning' : 'neutral'}
                    hint="Кандидаты на этапе owner_interview / offer"
                />
                <KpiTile
                    icon={TrendingUp}
                    label="Новых за 7 дней"
                    value={loading ? '…' : (s.new_candidates_7d ?? 0)}
                    tone={s.new_candidates_7d > 0 ? 'success' : 'neutral'}
                    hint="Новых заявок за последнюю неделю"
                />
            </div>

            {/* Quick nav widget */}
            <Widget
                title="Быстрые действия"
                badge={
                    <button
                        className="btn btn--ghost btn--xs"
                        onClick={() => load(true)}
                        disabled={refreshing}
                        title="Обновить"
                    >
                        <RefreshCw size={13} className={refreshing ? 'spin' : ''} />
                    </button>
                }
            >
                <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                    {[
                        { label: 'Воронка кандидатов', to: '/erp/pipeline' },
                        { label: 'Кандидаты', to: '/erp/candidates' },
                        { label: 'Вакансии', to: '/erp/vacancies' },
                        { label: 'Офферы', to: '/erp/offers' },
                    ].map(({ label, to }) => (
                        <button
                            key={to}
                            className="btn btn--secondary btn--sm"
                            style={{ justifyContent: 'space-between', display: 'flex', width: '100%' }}
                            onClick={() => navigate(to)}
                        >
                            {label}
                            <ArrowRight size={14} />
                        </button>
                    ))}
                </div>
            </Widget>
        </div>
    )
}
